import { render, staticRenderFns } from "./FavoriteIcon.vue?vue&type=template&id=4505d262&scoped=true"
import script from "./FavoriteIcon.vue?vue&type=script&lang=ts"
export * from "./FavoriteIcon.vue?vue&type=script&lang=ts"
import style0 from "./FavoriteIcon.vue?vue&type=style&index=0&id=4505d262&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4505d262",
  null
  
)

export default component.exports